module.exports = __webpack_public_path__ + "static/media/finances-tutorial3.3e292baa.png";